import { KleanadsScopeConfig } from '@pubstack/common/src/kleanadsScopeConfig'

export const DEFAULT_SCOPE_PREBID_VERSION = '10.27.0'

export function getDefaultKleanadsScopeConfig(kleanads_cdn_bucket: string): KleanadsScopeConfig {
  return {
    id: '',
    enabled: true,
    pbjsConfig: JSON.parse(`{"bidderAliases": []}`),
    scopeId: '[SCOPE_ID]',
    description: '[SCOPE_NAME]',
    context: [],
    networkId: 0,
    pbjsModuleBidAdapters: ['pubstackBidAdapter'],
    pbjsModuleOther: ['consentManagementTcf', 'currency', 'priceFloors', 'schain', 'gptPreAuction'],
    adCallTimeout: 3000,
    configUrl: `https://${kleanads_cdn_bucket}`,
    screenSizeBreakpoints: [
      {
        device: 'mobile',
        size: 0,
      },
      {
        device: 'desktop',
        size: 768,
      },
    ],
    metricThrottling: false,
    pbjsModulesHash: ' ',
    pbjs: {
      mainVersion: DEFAULT_SCOPE_PREBID_VERSION,
    },
    refreshEnable: true,
    globalRefreshConfig: {
      prebidOrderIds: [],
    },
    priceRuleBuckets: [
      {
        increment: '0.05',
        max: '5',
      },
    ],
  }
}
